import { createAsyncThunk } from '@reduxjs/toolkit';
import { getToken } from '../../Utils/authUtils';
import { _expressUrls } from '../../constant';

export interface GetClipSettingsPayload {
  studyUID: string;
}

/** Saved per-clip playback rates for a study, shared across the clinic. */
export const getClipSettings = createAsyncThunk(
  'express/getClipSettings',
  async (payload: GetClipSettingsPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }

      const response = await fetch(_expressUrls.GET_CLIP_SETTINGS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || `HTTP error! Status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
